import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './auth/guards/auth.guard';
import { NoAuthGuard } from './auth/guards/no-auth.guard';
import { InitialDataResolver } from './auth/resolvers/initial-data.resolver';
import { AboutPageComponent } from './home/about-page/about-page.component';
import { BaaComponent } from './home/baa/baa.component';
import { BillingPolicyPageComponent } from './home/billing-policy-page/billing-policy-page.component';
import { LicenseComponent } from './shared/components/license/license.component';
import { TermsPageComponent } from './shared/components/terms-page/terms-page.component';
import { TrainingComponent } from './home/training/training.component';
import { VideoChatComponent } from './video-chat/video-chat.component';

const routes: Routes = [
  // Redirect empty path to '/clinical'
  { path: '', pathMatch: 'full', redirectTo: 'clinical' },

  // Redirect signed in user to the '/clinical'
  //
  // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
  // path. Below is another redirection for that path to redirect the user to the desired
  // location. This is a small convenience to keep all main routes together here on this file.
  { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'clinical' },

  // Legacy Auth View
  {
    path: 'login-old',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
  },

  // New Auth Views

  {
    path: 'login',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    loadChildren: () => import('./auth/new-login/new-login.module').then((m) => m.NewLoginModule),
  },
  {
    path: 'new-provider-signup',
    loadChildren: () => import('./auth/new-provider-signup/new-provider-signup.module').then((m) => m.NewProviderSignupModule),
  },
  {
    path: 'new-user-signup',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    loadChildren: () => import('./auth/new-user-signup/new-user-signup.module').then((m) => m.NewUserSignupModule),
  },
  {
    path: 'forgot-password',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    loadChildren: () => import('./auth/forgot-password/forgot-password.module').then((m) => m.ForgotPasswordModule),
  },
  {
    path: 'mfa',
    canActivate: [],
    canActivateChild: [],
    loadChildren: () => import('./auth/mfa/mfa.module').then((m) => m.MfaModule),
  },

  // Auth Guard Routes
  {
    path: 'clinical',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    resolve: {
      initialData: InitialDataResolver,
    },
    loadChildren: () => import('./clinical/clinical.module').then((m) => m.ClinicalModule),
  },
  {
    path: 'consumer',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./consumer/consumer.module').then((m) => m.ConsumerModule),
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'practice',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./practice/practice.module').then((m) => m.PracticeModule),
  },
  {
    path: 'integrations',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./integrations/integrations.module').then((m) => m.IntegrationsModule),
  },

  // TODO: verify which of these routes require auth
  { path: 'video-chat/:patientId', component: VideoChatComponent },
  { path: 'video-chat', component: VideoChatComponent },
  { path: 'about', component: AboutPageComponent },
  { path: 'license', component: LicenseComponent },
  { path: 'terms', component: TermsPageComponent },
  { path: 'training', component: TrainingComponent },
  { path: 'billing', component: BillingPolicyPageComponent },
  { path: 'baa', component: BaaComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
